export default function (self, h) {
  const isMobile = /(android|ios|phone|mobile)/i.test(navigator.userAgent)
  return (
    <el-pagination
      class="pagination"
      layout={isMobile ? 'pager' : self.paginationLayout || 'total, sizes, prev, pager, next'}
      small={isMobile}
      total={self.tableData.total}
      pageSize={self.pageSize}
      pageSizes={self.pageSizes}
      currentPage={self.currentPage}
      on-size-change={self.handleSizeChange}
      on-current-change={self.handleCurrentChange}
    />
  )
}



// WEBPACK FOOTER //
// ./packages/creator/common/vnode/pagination.js